import React from 'react';
import { ListGroup } from 'react-bootstrap';
import { PanelType } from './SidebarNav';
import { useSelector } from 'react-redux';
import { getInitials } from '../../helpers/intials';
import {
  ListGroupButtonItem,
  ListGroupNavItem,
} from './ListGroupNavComponents';
import {
  useSitrepLandingFlag,
  useStreamlinePlatformFlag,
  useVelcoFlag,
  useDgptAlertsFlag,
} from '../../utils/featureFlags';
import { useSubscriptionLevel } from '../SubscriptionManagement/useSubscriptionLevel';

const MainNavPanel: React.FC<{
  setSecondPanel: (key: PanelType) => void;
}> = ({ setSecondPanel }) => {
  const velcoFlag = useVelcoFlag();
  const user = useSelector((state: any) => state.app.user);
  const sitrepLandingFlag = useSitrepLandingFlag();
  const streamlinePlatform = useStreamlinePlatformFlag();
  const dgptAlertsEnabled = useDgptAlertsFlag();
  const currentlySelected = useSelector(
    (state: any) => state.app.currentlySelectedGroup as Group
  );

  const { lockIncident, lockExercise, freemium, utilityImpactLevel } =
    useSubscriptionLevel();

  return (
    <nav aria-label="primary sidebar">
      <div className="org-label">
        <div className="avatar-initials sml me-2">
          {getInitials(currentlySelected.group_name)}
        </div>
        <div className="name-container">
          <div className="word-break">{currentlySelected.group_name}</div>
        </div>
      </div>

      {sitrepLandingFlag && (
        <ListGroup variant="flush">
          <div className="list-group-title">PRATUS AI SITREPS</div>
          <ListGroupNavItem
            to="/sitreps"
            icon="library_books"
            label="PRATUS AI SITREPS"
          />
        </ListGroup>
      )}

      <ListGroup variant="flush">
        <div className="list-group-title">Situational Awareness</div>
        <ListGroupNavItem
          to="/hub"
          icon="map"
          label="Hub"
          isDisabled={user?.external_user}
        />
        <ListGroupNavItem to="/org_files" icon="folder" label="Org Files" />
        {!streamlinePlatform && (
          <ListGroupButtonItem
            icon="notifications"
            label="Notifications"
            onClick={() => setSecondPanel('notifications')}
            isLocked={freemium}
          />
        )}
        {dgptAlertsEnabled && (
          <ListGroupNavItem
            to="/aialerts"
            icon="alarm"
            label="Alerts"
            isLocked={freemium}
          />
        )}
      </ListGroup>

      <ListGroup variant="flush">
        <div className="list-group-title">Incident Management</div>
        <ListGroupButtonItem
          icon="problem"
          label="Incident Management"
          onClick={() => setSecondPanel('ics')}
          isLocked={lockIncident}
        />
        {streamlinePlatform ? null : (
          <ListGroupButtonItem
            onClick={() => setSecondPanel('task')}
            icon="task"
            label="Task Management"
            isLocked={lockIncident}
          />
        )}
      </ListGroup>
      {!streamlinePlatform && (
        <>
          <ListGroup variant="flush">
            <div className="list-group-title">Exercise Management</div>
            <ListGroupButtonItem
              onClick={() => setSecondPanel('exercise')}
              icon="directions_run"
              label="Plan Exercise"
              isLocked={lockExercise}
            />
          </ListGroup>
        </>
      )}
      {velcoFlag && utilityImpactLevel !== 'None' && (
        <ListGroup variant="flush">
          <div className="list-group-title">Weather</div>
          <ListGroupNavItem
            to="/utility_impact_prediction"
            icon="report"
            label="Utility Impact Prediction"
          />
        </ListGroup>
      )}
      <ListGroup variant="flush">
        <div className="list-group-title">Settings</div>
        <ListGroupNavItem
          to="/groups"
          icon="settings"
          label="Org Settings"
          isDisabled={user?.external_user}
        />
      </ListGroup>
    </nav>
  );
};

export default MainNavPanel;
